import React, { useEffect, useState } from 'react';
import * as S from './styled';
import Input from '../../../../Input';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { useSnackbar } from 'notistack';

export default function FormInvoicePrint() {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [pdfUrl, setPdfUrl] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (newSelectedValues: string[]) => {
    setSelectedValues(newSelectedValues);
  };

  const options = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ];

  const createPdf = async () =>
    new Promise(async (resolve, reject) => {
      try {
        const headers = [
          'Nota',
          'Produto',
          'Quantidade',
          'Valor NF',
          'Valor real',
          'Custo total',
          'Custo unitário real',
          'Custo unitário total',
          'Lucro total',
          'Lucro unitário',
          'Venda unitária',
        ];

        const data = [
          ...Array.from({ length: 65 }, (_, i) => [
            `Dado ${i + 10}`,
            `Dado ${i + 11}`,
            `Dado ${i + 12}`,
          ]),
        ];

        const pdfDoc = await PDFDocument.create();
        const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold); // Fonte em negrito
        const fontSize = 8;
        const xStart = 0;
        const yStart = 550; // Ajuste para a nova altura
        const pageWidth = 842; // Largura para A4 paisagem
        const pageHeight = 595; // Altura para A4 paisagem
        const cellWidth = (pageWidth - xStart * 2) / headers.length;
        const cellHeight = 30;
        const lineColor = rgb(0, 0, 0);
        const headerColor = rgb(200 / 255, 200 / 255, 200 / 255); // Cinza claro
        const zebraColor1 = rgb(230 / 255, 230 / 255, 230 / 255); // Cinza muito claro
        const zebraColor2 = rgb(255 / 255, 255 / 255, 255 / 255); // Branco

        let yPosition = yStart;
        let pageNumber = 1;
        let page = pdfDoc.addPage([pageWidth, pageHeight]);

        const drawHeader = () => {
          const headerHeight = cellHeight;

          page.drawRectangle({
            x: xStart,
            y: yStart - headerHeight, // Ajusta a posição do cabeçalho
            width: pageWidth - xStart * 2,
            height: headerHeight,
            color: headerColor,
          });

          headers.forEach((headerText, colIndex) => {
            const x = xStart + colIndex * cellWidth;
            page.drawRectangle({
              x,
              y: yStart - headerHeight,
              width: cellWidth,
              height: headerHeight,
              borderColor: lineColor,
              borderWidth: 1,
            });

            page.drawText(headerText, {
              x: x + 5,
              y: yStart - fontSize - 5,
              size: fontSize,
              font: boldFont, // Fonte em negrito para o cabeçalho
              color: rgb(0, 0, 0),
            });
          });
          yPosition -= cellHeight;
        };

        // Adiciona o cabeçalho na primeira página
        drawHeader();

        for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
          // Adiciona numeração à página atual antes de criar uma nova
          if (yPosition - cellHeight < 50) {
            // Adiciona numeração à página atual
            page.drawText(`${pageNumber}`, {
              x: pageWidth - 60,
              y: pageHeight - 30,
              size: fontSize,
              font: font,
              color: lineColor,
            });

            // Adiciona uma nova página
            page = pdfDoc.addPage([pageWidth, pageHeight]);

            // Adiciona o cabeçalho na nova página
            drawHeader();

            yPosition = yStart;
            yPosition -= cellHeight;

            pageNumber++;
          }

          const isZebraRow = rowIndex % 2 === 0;

          // Adiciona linha de fundo para cada célula
          data[rowIndex].forEach((_, colIndex) => {
            const x = xStart + colIndex * cellWidth;
            const y = yPosition;
            const color = isZebraRow ? zebraColor1 : zebraColor2;

            // Desenha o fundo da célula
            page.drawRectangle({
              x,
              y: y - cellHeight,
              width: cellWidth,
              height: cellHeight,
              color,
            });

            // Desenha a borda da célula
            page.drawRectangle({
              x,
              y: y - cellHeight,
              width: cellWidth,
              height: cellHeight,
              borderColor: lineColor,
              borderWidth: 1,
            });

            // Adiciona o texto da célula
            page.drawText(`${data[rowIndex][colIndex]}`, {
              x: x + 5,
              y: y - fontSize - 5,
              size: fontSize,
              font, // Usa fonte em negrito se necessário
              color: lineColor,
            });
          });

          yPosition -= cellHeight;
        }

        // Adiciona numeração à última página
        page.drawText(`${pageNumber}`, {
          x: pageWidth - 60,
          y: pageHeight - 30,
          size: fontSize,
          font: font,
          color: lineColor,
        });

        const pdfBytes = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
        const pdfBlobUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfBlobUrl);
        resolve(true);
      } catch (error) {
        console.log(error);
        enqueueSnackbar(JSON.stringify(error), {
          variant: 'error',
        });
        reject(error);
      }
    });

  useEffect(() => {
    createPdf();
  }, []);

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          <S.ControlsContainer>
            <Input.Checkbox.Group
              options={options}
              selectedValues={selectedValues}
              onChange={handleChange}
              loading={false}
              disabled={false}
            />
          </S.ControlsContainer>
          <S.ViewContainer>
            <iframe
              style={{
                width: '100%',
                height: '75vh',
              }}
              src={pdfUrl}
            />
          </S.ViewContainer>
        </S.BodyContainer>
      </S.Body>
    </S.Form>
  );
}
